import React, { useCallback } from 'react';
import { IPanelProps } from '@fluentui/react';
import ChatPanel from 'features/chat/ChatPanel';
import { hideOfficeShellPanel, useAppDispatch, useAppSelector } from 'store';

import { FamilySettingsPanel as FamilySettings } from './FamilySettingsPanel';
import { NotificationSettingsPanel as NotificationSettings } from './NotificationSettingsPanel';
import { PrivacySettingsPanel as PrivacySettings } from './PrivacySettingsPanel';

export const OfficeShellPanel: React.FC<IPanelProps> = (props: IPanelProps) => {
  const dispatch = useAppDispatch();
  const officeShellPanelState = useAppSelector((state) => state.layout.officeShellPanel);

  const onDismiss = useCallback(() => {
    dispatch(hideOfficeShellPanel());
  }, [dispatch]);

  // eslint-disable-next-line react/destructuring-assignment
  switch (officeShellPanelState?.panelType) {
    case 'NotificationSettings':
      return <NotificationSettings onDismiss={onDismiss} {...officeShellPanelState} {...props} />;
    case 'FamilySettings':
      return <FamilySettings onDismiss={onDismiss} {...officeShellPanelState} {...props} />;
    case 'PrivacySettings':
      return <PrivacySettings onDismiss={onDismiss} {...officeShellPanelState} {...props} />;
    case 'GlobalCopilot':
      return <ChatPanel onDismiss={onDismiss} {...officeShellPanelState} {...props} />;
    default:
      return null;
  }
};
